import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { Box, TextField, Button, CircularProgress } from '@material-ui/core';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import { initialValues, validationSchema } from 'forms/buyerRegistrationForm';
import i18n from 'i18next';
import PhoneInput from './components/PhoneInput';
import useStyles from './useStyles';

const BuyerRegistrationForm = props => {
  const { t } = useTranslation();
  // const [isPasswordVisible, setPasswordVisible] = useState(false);
  const classes = useStyles();

  const { onSubmit, buttonLabel, isSigningUp } = props;

  const formik = useFormik({
    validationSchema,
    initialValues,
    onSubmit,
  });

  const { errors, values, handleChange, handleBlur, touched, handleSubmit } = formik;

  const isAbleToSubmit = isEmpty(errors);

  // const handleClickShowPassword = () => setPasswordVisible(!isPasswordVisible);
  return (
    <Box className={classes.paper}>
      <form className={classes.form} onSubmit={handleSubmit}>
        <TextField
          error={touched.firstName && (Boolean(errors.firstName) || Boolean(errors.serverError))}
          helperText={touched.firstName && t(errors.firstName)}
          variant="outlined"
          id="firstName"
          name="firstName"
          type="firstName"
          placeholder={t('components.LoanOfficerRegistrationForm.firstName')}
          autoComplete="given-name"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.firstName}
          className={classes.field}
        />
        <TextField
          error={touched.lastName && (Boolean(errors.lastName) || Boolean(errors.serverError))}
          helperText={touched.lastName && t(errors.lastName)}
          variant="outlined"
          id="lastName"
          name="lastName"
          type="lastName"
          placeholder={t('components.LoanOfficerRegistrationForm.lastName')}
          autoComplete="family-name"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.lastName}
          className={classes.field}
        />
        <TextField
          error={touched.email && Boolean(errors.email)}
          helperText={
            (touched.email && t(errors.email)) || (
              <span className={classes.caption}>
                <Icon name="lock" width="16px" height="16px" style={{ marginRight: '2px' }} />
                {t('components.BuyerRegistrationForm.caption')}
              </span>
            )
          }
          variant="outlined"
          id="email"
          name="email"
          type="email"
          placeholder={t('components.BuyerRegistrationForm.email')}
          autoComplete="email"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          className={classes.field}
        />
        <TextField
          error={touched.phoneNumber && Boolean(errors.phoneNumber)}
          helperText={touched.phoneNumber && t(errors.phoneNumber)}
          variant="outlined"
          className={classes.field}
          color="primary"
          placeholder="(123) 456-7890"
          id="phoneNumber"
          name="phoneNumber"
          autoComplete="tel"
          type="text"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.phoneNumber}
          InputProps={{
            style: {},
            inputComponent: PhoneInput,
          }}
          InputLabelProps={{
            shrink: false,
          }}
        />
        {/* <TextField
          error={touched.password && Boolean(errors.password)}
          helperText={touched.password && t(errors.password)}
          variant="outlined"
          name="password"
          type={isPasswordVisible ? 'text' : 'password'}
          id="password"
          placeholder={t('components.BuyerRegistrationForm.password')}
          autoComplete="new-password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          className={classes.field}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isPasswordVisible ? (
                  <Icon name="visible" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                ) : (
                  <Icon name="visibleOff" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                )}
              </InputAdornment>
            ),
          }}
        /> */}
        <Button className={classes.button} type="submit" disabled={!isAbleToSubmit}>
          {isSigningUp ? <CircularProgress className={classes.loader} size={20} /> : buttonLabel}
        </Button>
      </form>
    </Box>
  );
};

BuyerRegistrationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
};

BuyerRegistrationForm.defaultProps = {
  buttonLabel: i18n.t('components.BuyerRegistrationForm.button'),
};

export default BuyerRegistrationForm;



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRegistrationForm/BuyerRegistrationForm.js